export const singleTitleMapping = {
  "/": "Dashboard",
  "/index": "Dashboard",
  "/my-profile": "Profile",
  "/employee-profile": "Employee Profile",
  "/hotels": "Hotels",
  "/transaction": "Transaction",
  "/room-booking-list": "Booking List",
  "/checkin-out": "Check Out",
  "/room-status": "Room Status",
  "/room-facilites-list": "Facilites List",
  "/facilites-details": "Facilites Details List",
  "/room-size": "Room Size List",
  "/housekeeping-assign-room": "Assign House Keeping",
  "/housekeeping-roomcleaning": "Room Cleaning List",
  "/housekeeping-checklist": "Housekeeping Checklist",
  "/housekeeping-qrlist": "Room QR-List",
  "/housekeeping-report": "Cleaning Report",
  "/cab-list": "Cab List",
  "/cab-booking": "Cab Booking",
  "/items-unit-list": "Unit Items List",
  "/items-list": "Items List",
  "/items-destroyed-list": "Destroyed List",
  "/items-category-list": "Category List",
  "/items-suppliers-list": "Suppliers List",
  "/personalised": "Personalised",
  "/personalised-jacuzzi": "Jacuzzi Booking",
  "/personalised-swimmingpool": "Swimming Pool Booking",
  "/personalised-spa": "Spa Booking",
  "/personalised-pedicure": "Body Massage and Pedicure Booking",
  "/personalised-theater": "Theater Booking",
  "/personalised-banquet": "Banquet Booking",
  "/personalised-settings": "Personalised Settings",
  "/booking-report": "Booking Reports",
  "/purchase-report": "Purchase Report",
  "/stock-report": "Stock Report",
  "/bed-list": "Bed List",
  "/booking-type-list": "Booking Type List",
  "/commission-list": "Commission List",
  "/complementary-list": "Complementary List",
  "/floor-plan-list": "Floor Plan List",
  "/room-list": "Room List",
  "/room-type":"Room Type List",
  "/room-image": "Room Images",
  "/promocode-list": "Promocode List",
  "/room-booking": "Room Booking",
  "/index-hr": "Dashboard",
  "/hrms": "HRMS",
  "/duty-assigned-list": "Assigned Employee List",
  "/duty-shift-list": "Duty Shift List",
  "/duty-roster-list": "Duty Roster List",
  "/employees-all": "Employee",
  "/employees-leave": "Leave Request",
  "/employees-attendance": "Attendance",
  "/employees-departments": "Departments",
  "/employees-loan": "Employee Loan",
  "/employees-appraisal": "Employee Appraisal",
  "/employees-add": "Add Employees",
  "/payroll-employee-salary": "Employee Salary",
  "/payroll-payslip": "Payslip",
  "/payroll-report": "Report",
  "/tuning": "Tuning",
  "/common-settings": "Common Settings",
  "/payment-set": "Payment Settings",
  "/accounts-setting": "Accounts Settings",
  "/role-add": "Add Role",
  "/role-list": "Role List",
  "/role-permission": "Role Permission",
  "/role-create-list": "Role Create List",
  "/role-assign": "Role Assign",
  "/role-access-list": "Role Access List",
  "/about-us": "About Us",
  "/contact-us": "Contact Us",
  "/privacy-policy": "Privacy Policy",
  "/terms-conditions": "Terms Conditions",
  "/calendar": "Calendar",
  "/inbox": "Inbox",
  "/chat": "Chat",
  "/blog": "Blog",
  "/blog-detail": "BlogDetail",
  "/filemanager": "File Manager",
  "/search": "Search Page",
  "/changelog": "Changelog",
  "/app": "Apps",
  "/calender-view": "Calendar View",
  "/room-view": "Room View",
  "/guest-database": "Guest Database",
  "/edit-guest-database": "Edit Guest Database",
  "/night-audit": "Night Audit",
  "/pos": "POS",
  "/kot": "KOT",
  "/revenue": "Revenue",
  "/reports": "Reports",
  "/hrms-dashboard": "HRMS Dashboard",
  "/live-logs": "Live Logs",
  "/audit": "Audit",
  "/employee-management": "Employee Management",
  "/duty-roster": "Duty Roster",
  "/hrms-reports": "HRMS Reports",
  "/attendance": "Attendance",
  "/hrms-reports/hrms-attendance": "Consolidated Attendance Report",
  "/hrms-reports/hrms-leave-report": "Leave",
  "/hrms-reports/late-comers": "Late Comers",
  "/hrms-reports/early-going": "Early Going",
  "/hrms-reports/department-consolidated": "Department consolidated",
  "/devices": "Device Management",
  "/users": "Users",
  "/email-logs": "Email Logs",
  "/settings": "Settings",
};

export const resolveBreadcrumbTitles = (pathname, titleMap) => {
  const segments = pathname.split("/").filter(Boolean);
  const breadcrumbParts = [];

  // Build up from root to full path
  for (let i = 0; i < segments.length; i++) {
    const path = "/" + segments.slice(0, i + 1).join("/");
    if (titleMap[path]) breadcrumbParts.push({ path, title: titleMap[path] });
  }

  // Fallback if nothing matches
  if (breadcrumbParts.length === 0)
    breadcrumbParts.push({ path: pathname, title: "Dashboard" });

  return breadcrumbParts;
};
